<template>
  <div class="router-video-box" ref="routerViewBox">
    <stageChangeAnimate>
      <router-view :key="$route.name" />
    </stageChangeAnimate>
  </div>
</template>

<script>
import { mapState, mapMutations, mapGetters } from "vuex";
import { get_schema } from "utils/ajax";
import { checkRoutePath, i18n } from "utils/util";
import NProgress from "nprogress";
import stageChangeAnimate from "./components/stage-change-animate/index.vue";
import ImagePreloader from "image-preloader";

export default {
  components: {
    stageChangeAnimate,
  },
  computed: {
    ...mapState("global", ["preloading", "schema", "isShowAside"]),
    ...mapGetters("global", ["aside"]),
  },
  data() {
    return {
      customRoutes: this.$router.options.routes,
    };
  },
  created() {
    NProgress.configure({ showSpinner: false });
    NProgress.start();
    this.fetchData(this.$route.path, this.$route.name).then(NProgress.done);

    //  监听全局导航护卫
    this.$router.beforeEach((to, from, next) => {
      NProgress.start();
      this.fetchData(to.path, to.name).then((data) => {
        NProgress.done();
        next();
        this.$P.$emit("route_before_change", { to, from, name: data.name });
        this.update_body_slug(data.name);
      });
    });
  },
  mounted() {
    this.update_body_slug(this.$route.name);
  },
  methods: {
    ...mapMutations("global", [
      "updateSchema",
      "updateShowAside",
      "updatePreloadingDone",
    ]),
    async fetchData(toPath = "/home", toName = "home") {
      await this.load_first_page_background(toPath);
      if (!this.schema[this.get_router_name(toName)]) {
        this.updateSchema({
          name: this.get_router_name(toName),
          value: await get_schema(
            this.get_schema_path(checkRoutePath(toPath, this.aside))
          ),
        });
      }

      return Promise.resolve(this.schema[this.get_router_name(toName)]);
    },

    update_body_slug(name) {
      document.body.dataset.slug = name;
    },

    load_first_page_background(toPath) {
      return new Promise((res) => {
        let target = this.$router.options.routes.find(
          (item) => item.path === toPath
        );
        if (target?.meta?.prefetchAssets?.assets) {
          let images = target.meta.prefetchAssets.assets.map((i) => i18n(i));

          new ImagePreloader().preload(...images).then((status) => {
            res();
          });
        } else {
          res();
        }
      });
    },
  },
};
</script>
